import React from 'react';

import { Box } from '@material-ui/core';
import cx from 'classnames';

import PlayLargeIcon from '../../../../assets/icons/PlayLargeIcon';
import { colorsPalette } from '../../../../theme';
import useCardStyles from '../../styles';
import useStyles from './styles';

interface CardPlayIconProps {
  wrapperClass?: string;
  iconClass?: string;
}

const CardPlayIcon: React.FC<CardPlayIconProps> = ({ wrapperClass, iconClass }) => {
  const classes = { ...useStyles(), ...useCardStyles() };

  return (
    <Box className={cx(classes.iconWrapper, wrapperClass)}>
      <PlayLargeIcon className={cx(classes.playIcon, iconClass)} color={colorsPalette.white} />
    </Box>
  );
};

export default CardPlayIcon;
